import { Scale, ShieldAlert, GitMerge, Sprout } from 'lucide-react';
import type { BoardFocusArea } from '../types/content';

export const boardFocusAreas: BoardFocusArea[] = [
  {
    icon: Scale,
    title: 'Corporate Governance',
    description: 'Bringing board-level discipline to oversight, accountability, and enterprise decision-making.'
  },
  {
    icon: ShieldAlert,
    title: 'Risk & Change Management',
    description: 'Guiding organizations through structural, technological, and market-driven change with control.'
  },
  {
    icon: GitMerge,
    title: 'M&A / Joint Ventures',
    description: 'Structuring transactions and alliances that create durable, mutually accretive value.'
  },
  {
    icon: Sprout,
    title: 'Sustainable Enterprise Growth',
    description: 'Balancing near-term performance with long-term resilience and stakeholder value.'
  }
];
